import type { OperationType } from "../operation-types";
import { escapeIdentifier } from "./escape-identifier";

export const aggregateToSql = (column: string, op: OperationType): string => {
  const col = escapeIdentifier(column);
  const asVarchar = `CAST(${col} AS VARCHAR)`;
  const isEmpty = `(${col} IS NULL OR ${asVarchar} = '')`;

  switch (op) {
    case "SUM":
      return `SUM(${col})`;
    case "MEAN":
      return `AVG(${col})`;
    case "MIN":
      return `MIN(${col})`;
    case "MAX":
      return `MAX(${col})`;
    case "COUNT":
      return "COUNT(*)";
    case "COUNT_VALUE":
      return `COUNT(${col})`;
    case "COUNT_EMPTY":
      return `SUM(CASE WHEN ${isEmpty} THEN 1 ELSE 0 END)`;
    case "COUNT_UNIQUE":
      return `COUNT(DISTINCT ${col})`;
    case "COUNT_TRUE":
      return `SUM(CASE WHEN ${col} = TRUE THEN 1 ELSE 0 END)`;
    case "COUNT_FALSE":
      return `SUM(CASE WHEN ${col} = FALSE THEN 1 ELSE 0 END)`;
    case "MEDIAN":
      return `MEDIAN(${col})`;
    case "VARIANCE":
      return `VAR_SAMP(${col})`;
    case "PERCENTAGE_EMPTY":
      return `SUM(CASE WHEN ${isEmpty} THEN 1.0 ELSE 0.0 END) / NULLIF(COUNT(*), 0)`;
    case "PERCENTAGE_NON_EMPTY":
      return `SUM(CASE WHEN NOT ${isEmpty} THEN 1.0 ELSE 0.0 END) / NULLIF(COUNT(*), 0)`;
    case "PERCENTAGE_TRUE":
      return `SUM(CASE WHEN ${col} = TRUE THEN 1.0 ELSE 0.0 END) / NULLIF(COUNT(*), 0)`;
    case "PERCENTAGE_FALSE":
      return `SUM(CASE WHEN ${col} = FALSE THEN 1.0 ELSE 0.0 END) / NULLIF(COUNT(*), 0)`;
    case "CONCAT":
      return `STRING_AGG(${asVarchar}, ', ')`;
    default:
      return `MIN(${col})`;
  }
};
